(function () {
  function initReviewLinks() {
    var modal = document.getElementById('customReviewModal');
    var form = document.getElementById('customReviewForm');
    var waiting = false;

    function requestNativeReviewForm() {
      if (waiting) return;
      waiting = true;
      document.documentElement.dataset.pwReviewsRequested = 'true';
      document.dispatchEvent(new CustomEvent('pw:reviews:load'));
      var observer;
      var timeout;

      function cleanup() {
        if (observer) observer.disconnect();
        if (timeout) window.clearTimeout(timeout);
        waiting = false;
      }

      function tryOpen() {
        var trigger = document.querySelector('#judgeme_product_reviews [data-testid="write-review-button"], #judgeme_product_reviews .jdgm-write-rev-link');
        if (!trigger || trigger.disabled) return false;
        cleanup();
        if (modal && modal.open) modal.close();
        trigger.click();
        return true;
      }

      if (tryOpen()) return;
      observer = new MutationObserver(tryOpen);
      observer.observe(document.body, { childList: true, subtree: true });
      timeout = window.setTimeout(function () {
        cleanup();
        var widget = document.getElementById('judgeme_product_reviews');
        if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 10000);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('#writeReviewBtn');
      if (!trigger) return;
      event.preventDefault();
      requestNativeReviewForm();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        requestNativeReviewForm();
      });
    }

    var savedUrl = null;
    try {
      savedUrl = window.sessionStorage.getItem('savedReviewUrl');
      if (savedUrl) window.sessionStorage.removeItem('savedReviewUrl');
    } catch (error) {}

    var candidates = [savedUrl, window.customReviewInitialUrl, window.location.href];
    var requested = candidates.some(function (value) {
      if (!value) return false;
      try {
        var url = new URL(value, window.location.href);
        return url.searchParams.has('write_review') || url.searchParams.get('review') === 'true' || url.hash.toLowerCase().indexOf('write_review') !== -1;
      } catch (error) {
        return false;
      }
    });
    if (requested) requestNativeReviewForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewLinks, { once: true });
  } else {
    initReviewLinks();
  }
})();
